<template>
  <client-only>
    <v-text-field
      v-model="userNameNew"
      :label="formLabel"
      solo
      type="text"
      :rules="nameRules"
      rounded
      prepend-inner-icon="mdi-account"
      required
      outlined
      dense
    ></v-text-field>
  </client-only>
</template>

<script>
import { nameRules } from '@/lib/rules.js';

export default {
  props: {
    formLabel: {
      type: String,
    },
  },

  data() {
    return {
      userNameNew: '',
      nameRules,
    };
  },

  computed: {
    isName() {
      return this.formLabel === 'שם פרטי' ? true : false;
    },
  },

  methods: {
    applyNewName() {
      this.$emit('newName', this.userNameNew);
    },
    applyNewLastName() {
      this.$emit('newLastName', this.userNameNew);
    },
  },

  watch: {
    userNameNew() {
      if (this.isName) {
        this.applyNewName();
      } else {
        this.applyNewLastName();
      }
    },
  },
};
</script>